<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <polygon
        points="13.682,4.4253 15.9961,3.2683 17.7317,5.0039 16.5747,7.318 17.0455,8.4545 19.5,9.2727 19.5,11.7273 17.0455,12.5455 16.5747,13.682 17.7317,15.9961 15.9961,17.7317 13.682,16.5747 12.5455,17.0455 11.7273,19.5 9.2727,19.5 8.4545,17.0455 7.318,16.5747 5.0039,17.7317 3.2683,15.9961 4.4253,13.682 3.9545,12.5455 1.5,11.7273 1.5,9.2727 3.9545,8.4545 4.4253,7.318 3.2683,5.0039 5.0039,3.2683 7.318,4.4253 8.4545,3.9545 9.2727,1.5 11.7273,1.5 12.5455,3.9545"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <circle
        cx="10.5"
        cy="10.5"
        r="3"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
